import { RawDraftContentState } from 'draft-js';

import { isDefined } from '../ramda';

/**
 * Checks whether WYSIWYG raw object is defined or it's empty
 * @param structure - WYSIWYG raw object
 * @returns {*|boolean}
 */
export function isWYSIWYGStructureDefined(structure?: RawDraftContentState | null) {
  if (!structure) {
    return false;
  }
  const blocksExist = isDefined(structure?.blocks);
  const blocksNotEmpty = structure?.blocks?.length > 0;
  const firstBlockHasText = isDefined(structure?.blocks?.[0]?.text);
  const blocksMoreThanOne = structure?.blocks?.length > 1;

  return blocksExist && blocksNotEmpty && (firstBlockHasText || blocksMoreThanOne);
}
